// The prototype's sample files (50-customers.js SAMPLE_CSV), so "Use a sample file" works the same.
export const SAMPLE_CUSTOMERS_CSV = `Customer name,Arabic name,TRN,Contact,Phone,Email
Sample Building Contracting,سامبل لمقاولات البناء,100000000002403,Rami S.,+971 4 000 0100,ap@samplebuilding.example
Demo Steel Works,ديمو لأعمال الحديد,100000000000703,Yousef H.,+971 2 000 0400,ar@demosteel.example
Demo General Trading,,100000000002503,Salem A.,+971 2 000 0090,accounts@demogeneral.example
Demo Facilities,,1005544,Ann M.,+971 4 000 0233,facilities@demofacilities
Sample Landscaping LLC,سامبل لتنسيق الحدائق ذ.م.م,,Noura K.,+971 50 000 0210,noura@samplelandscaping.example`;

// prototype 35-cheques.js SAMPLE_CHQ_CSV; DATE1 = today + 20 days, DATE2 = + 92 days, DATE3 = 4 days ago
const dmy = (d: Date) => String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear();
export function sampleChequesCSV(now = Date.now()) {
  const day = (n: number) => { const d = new Date(now); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() + n); return dmy(d); };
  return `Customer,Cheque number,Bank,Cheque date,Amount,Currency,Paper receipt,Holder email
Sample Building Contracting,104455,ENBD,DATE1,48000,AED,3398,
Demo Steel Works,220871,FAB,DATE2,125500,AED,3402,
Demo General Trading,331902,MSQ,DATE3,9750,AED,3355,
Sample Landscaping LLC,447120,ENBD5,DATE1,15000,AED,3410,
Sample Building Contracting,104455,ENBD,DATE1,48000,AED,3398,`.replace(/DATE1/g, day(20)).replace(/DATE2/g, day(92)).replace(/DATE3/g, day(-4));
}
